import { render, staticRenderFns } from "./DetailAttempts.vue?vue&type=template&id=9a6a7dd4&"
import script from "./DetailAttempts.vue?vue&type=script&lang=js&"
export * from "./DetailAttempts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports